import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "ticketino-api-client";
import axios from "axios";

import Header from "./components/Header";

import homeImg1 from "../images/sponser-speaker-img_1.png";
import homeImg2 from "../images/sponser-speaker-img_2.png";

const SponsorSpeaker_Home = () => {
    const [orderId, setOrderId] = useState();

    const [eventId, setEventId] = useState([]);
    const [posId, setPosId] = useState();

    const [loaded, setLoaded] = useState(false);

    const [selectedIam, setSelectedIam] = useState("");
    const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    const { language } = useParams();

    // Ref for language menu
    const languageMenuRef = useRef(null);

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        // Remove addressBody from localStorage on first page load
        localStorage.removeItem("selectedIam");
        loadToken();

        // clear the addedPromocodes in the session
        let array = [];
        sessionStorage.setItem("AddedPromotionsSponsorSpeaker", JSON.stringify(array));
    }, []); //only on first page load

    useEffect(() => {
        requestResources();

        // so it wont get called on first load
        if (loaded) {
            startOrder(posId, eventId);
        }
    }, [language]); //everytime language is changed

    // Close language menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (languageMenuRef.current && !languageMenuRef.current.contains(event.target)) {
                setIsLanguageMenuOpen(false);
            }
        };

        if (isLanguageMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isLanguageMenuOpen]);

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            sessionStorage.setItem("token", res.data);

            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            // setting the posID and eventID
            setPosId(res.data.posId);
            setEventId(res.data.eventId);

            startOrder(res.data.posId, res.data.eventId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const startOrder = async (posId, eventId) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            languageId: languageId,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 1,
        };

        await axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("orderId", res.data.id);
                setOrderId(res.data.id);
                setLoaded(true);
            })
            .catch((error) => console.error(error.response.data));
    };

    const onSubmit = async () => {
        try {
            await addAddressToBasket();
        } catch (error) {
            // Optionally set a generic error message
        }
    };

    const addAddressToBasket = async () => {
        // Store SelectedIam in localStorage for later use
        localStorage.setItem("SponsorSpeakerOption1", selectedIam);
        // Navigate to the next step
        navigate(`/${language}/sponsor-speaker/tickets`);
    };

    const handleLanguageChange = (newLanguage) => {
        setIsLanguageMenuOpen(false);
        navigate(`/${newLanguage}/sponsor-speaker/home`);
    };

    // Computed variable for Next button disabled state (AGB3 not considered)
    const isNextDisabled =
        selectedIam === "";

    return (
        <div className="page-container">
            <Header language={language} />

            <div className="container wrapper-language-switcher">
                {/* Language Switcher */}
                <div className="text-center" style={{ position: "relative", cursor: "pointer", maxWidth: "80px", fontFamily: "Arial, sans-serif", fontWeight: "300", color: "#093064" }}>
                    <div onClick={() => setIsLanguageMenuOpen(!isLanguageMenuOpen)}>
                        <span className="pe-3">{language?.toUpperCase()}</span>
                        {isLanguageMenuOpen ? (
                            <svg style={{ marginTop: "-3px" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.283 4.898" style={{ width: '14px', height: '14px', transform: 'rotate(180deg)' }}>
                                <path d="M4.641 4.898a.5.5 0 0 1-.343-.136L.158.864A.5.5 0 0 1 .842.136L4.64 3.712 8.44.136a.5.5 0 0 1 .686.729L4.984 4.762a.5.5 0 0 1-.343.136Z"></path>
                            </svg>
                        ) : (
                            <svg style={{ marginTop: "-3px" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.283 4.898" style={{ width: '14px', height: '14px' }}>
                                <path d="M4.641 4.898a.5.5 0 0 1-.343-.136L.158.864A.5.5 0 0 1 .842.136L4.64 3.712 8.44.136a.5.5 0 0 1 .686.729L4.984 4.762a.5.5 0 0 1-.343.136Z"></path>
                            </svg>
                        )}
                    </div>
                    {isLanguageMenuOpen && (
                        <div style={{ position: "absolute", top: "100%", left: "0", right: "0", backgroundColor: "white", zIndex: 1000 }}>
                            <hr className="mt-2 mb-2" />
                            <div onClick={() => handleLanguageChange(language?.toUpperCase() === 'DE' ? 'en' : 'de')}>
                                <span>{language?.toUpperCase() === 'DE' ? 'EN' : 'DE'}</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="container wrapper-small">

                <div className="row mt-5">
                    <div className="col-md-12">
                        <span className="text-title d-block">{resources?.EventName}</span>
                        <span className="text-subtitle d-block">{resources?.SpeakerSponsorHomeTitle}</span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-12">
                        <span>{resources?._Iam}</span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-6">
                        {/* I am - radiobutton group */}

                        <img className="img-fluid" src={homeImg2} alt="home" />

                        {/* Professional */}
                        <label className="d-flex align-items-center mt-4" style={{ cursor: "pointer" }}>
                            <input
                                type="radio"
                                name="iam"
                                value={resources?.SponsorSpeakerIamValue1}
                                checked={selectedIam === resources?.SponsorSpeakerIamValue1}
                                onChange={() => setSelectedIam(resources?.SponsorSpeakerIamValue1)}
                                className="d-none"
                            />
                            <i className={`bi bi${selectedIam === resources?.SponsorSpeakerIamValue1 ? "-check" : ""}-circle me-2`}></i>
                            <span>{resources?.SponsorSpeakerIamValue1}</span>
                        </label>
                    </div>

                    <div className="col-6">
                        <img className="img-fluid" src={homeImg1} alt="home" />

                        {/* Private */}
                        <label className="d-flex align-items-center mt-4" style={{ cursor: "pointer" }}>
                            <input
                                type="radio"
                                name="iam"
                                value={resources?.SponsorSpeakerIamValue2}
                                checked={selectedIam === resources?.SponsorSpeakerIamValue2}
                                onChange={() => setSelectedIam(resources?.SponsorSpeakerIamValue2)}
                                className="d-none"
                            />
                            <i className={`bi bi${selectedIam === resources?.SponsorSpeakerIamValue2 ? "-check" : ""}-circle me-2`}></i>
                            <span>{resources?.SponsorSpeakerIamValue2}</span>
                        </label>
                    </div>
                </div>
            </div>

            {/* next button*/}
            <div className="container wrapper-small">
                <div className="row mt-5">

                    <div className="col-md-12 text-end">
                        <button className="btn button-custom" onClick={() => onSubmit()} disabled={isNextDisabled}>{resources?.Next}</button>
                    </div>
                </div>

                <p className="mt-4">
                    <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                </p>
            </div>
        </div>
    )
}

export default SponsorSpeaker_Home